<template lang="pug">
  WtTile#wellness-challenge(ancestor vertical)
    WtTile(parent)
      WtTile(child :col="12" child-class="")
        WellnessChallengeHeader
    WellnessChallengeQuestionsNotification
    WtTile(parent)
      WtTile(child :col="12")
        WellnessMemberOverview(:pacerValue="pacerValue")
    WtTile(parent)
      WtTile(child :col="12" :is-loading="!leaderboardLoaded" child-class="")
        BCollapse.card(
            aria-id="wellnessLeaderboard"
            :open.sync="wellnessLeaderboardOpen"
            class="custom-collapse"
        )
          .card-header(
            slot='trigger'
            role='button'
            aria-controls='wellnessLeaderboard'
          )
            .card-header-title
              WtTitle Challenge Leaderboard
            a.card-header-icon
              BIcon(:icon="wellnessLeaderboardOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
          .card-content
            WellnessLeaderboard(:pacerValue="pacerValue")
    WtTile(parent)
      WtTile(child :col="12" :is-loading="!discussionLoaded || joining")
        Discussion(
          title="Join the discussion!"
          :data-object="getDiscussionById(challengeId)"
          :fetch-action="fetchDiscussion"
          :challenge="getChallengeById(challengeId)"
        )

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import { challengeMixin } from "@/mixins/challengeMixin";
import WtButton from "@@/WtButton/WtButton";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtLeaderboard from "@@/WtLeaderboard/WtLeaderboard";
import Discussion from "@@/Challenge/Discussion";
import ChallengeJoinButton from "@@/Challenge/ChallengeJoinButton";
import WellnessChallengeHeader from "@@/Challenge/WellnessChallenge/WellnessChallengeHeader";
import WellnessMemberOverview from "@@/Challenge/WellnessChallenge/WellnessMemberOverview";
import WellnessLeaderboard from "@@/Challenge/WellnessChallenge/WellnessLeaderboard";
import WellnessChallengeQuestionsNotification from "@@/Challenge/WellnessChallenge/WellnessChallengeQuestionsNotification";

export default {
  name: "WellnessChallenge",

  components: {
    WtButton,
    WtTile,
    WtTitle,
    WtLeaderboard,
    Discussion,
    ChallengeJoinButton,
    WellnessChallengeHeader,
    WellnessMemberOverview,
    WellnessLeaderboard,
    WellnessChallengeQuestionsNotification
  },

  mixins: [dateUtilityMixin, challengeMixin],

  data() {
    return {
      wellnessLeaderboardOpen: true
    };
  },

  computed: {
    ...mapGetters("pages", ["isPageLoaded", "isPageLoading"]),
    ...mapGetters("authMember", ["isAdmin"]),
    ...mapGetters("challenges", [
      "getDiscussionById",
      "discussionLoaded",
      "getLeaderboardById",
      "leaderboardLoaded",
      "getAggregateById",
      "aggregateLoaded",
      "joining",
      "getChallengeById"
    ]),
    ...mapGetters("members", [
      "getMilestonesById",
      "milestonesLoaded",
      "challenges",
      "memberTeamsLoaded"
    ]),
    ...mapGetters("program", ["coreProgramMeta", "programTeamsLoaded"]),

    page() {
      return `Challenge${this.challengeId}`;
    },

    challengeId() {
      return this.$route.params.challengeId;
    },

    challenge() {
      return this.getChallengeById(this.challengeId);
    },

    isCompleted() {
      const COMPLETED = 2;
      return (
        this.getChallengeById(this.$route.params.challengeId).status ===
        COMPLETED
      );
    },

    thisMembersPoints() {
      const leaderboard = this.getLeaderboardById(this.challengeId);
      const member = leaderboard.find(member => {
        return member.id === this.$auth.user().id;
      });
      return member ? member.points : null;
    },

    pacerValue() {
      let daysElapsed;
      if (this.isTodayBeforeChallengeStart(this.challenge)) {
        daysElapsed = 0;
      } else if (this.isTodayAfterChallengeEnd(this.challenge)) {
        daysElapsed = this.daysBetweenInclusive(
          this.challenge.startDate,
          this.challenge.endDate
        );
      } else {
        daysElapsed = this.daysBetweenInclusive(
          this.challenge.startDate,
          this.moment().format("YYYY-MM-DD")
        );
      }
      // wellness challenge are 42 days long or 6 weeks.
      // compute the pacer value based on what the pacer averages per day of challenge length
      let daysInChallengeCountedTowardsGoal = this.daysBetweenInclusive(
        this.challenge.startDate,
        this.challenge.endDate
      );
      // NOTE: goal per day is a "rounded" value since goal is computed by counting points for a fraction of the days in the challenge
      //   and questions, journal entries, and weight points are not awarded daily.
      let goalPerDay =
        this.challenge.totalPointsGoal / daysInChallengeCountedTowardsGoal;

      let pacerValue = goalPerDay * daysElapsed;

      return pacerValue > this.challenge.totalPointsGoal
        ? this.challenge.totalPointsGoal
        : pacerValue;
    }
  },

  watch: {
    wellnessLeaderboardOpen(newValue) {
      localStorage[
        `wellnessLeaderboardOpen-${this.$auth.user().id}`
      ] = newValue;
    }
  },

  mounted() {
    if (
      localStorage[`wellnessLeaderboardOpen-${this.$auth.user().id}`] !==
      undefined
    ) {
      this.wellnessLeaderboardOpen =
        localStorage[`wellnessLeaderboardOpen-${this.$auth.user().id}`] ===
        "true";
    }
  },

  methods: {
    ...mapActions("pages", ["setPageLoaded", "setPageLoading"]),
    ...mapActions("challenges", [
      "fetchChallenge",
      "join",
      "fetchChallengeDiscussion",
      "fetchLeaderboard",
      "fetchChallengeAggregate"
    ]),
    ...mapActions("members", ["fetchMilestones", "fetchMemberTeams"]),
    ...mapActions("program", ["fetchProgramTeams"]),
    ...mapActions(["snackBar"]),

    fetchDiscussion(photosOnly = false, page = null) {
      return this.fetchChallengeDiscussion({
        challengeId: this.challengeId,
        photosOnly,
        page
      });
    }
  }
};
</script>

<style lang="sass" scoped>
#wellness-challenge
</style>
